<dgx-components-card
  [dropShadow]="false"
  [spacing]="1"
  [theme]="'background-alternative'"
  class="mb-3"
>
  <div class="card-container">
    <div class="data-container">
      <dgx-components-icon
        [icon]="icon"
        [size]="'xl'"
        class="brand-colour mr-3"
      />
      <p class="typog-body-bold">{{ brandName }} {{ appliance }}</p>
    </div>
  </div>
</dgx-components-card>
